export const LOCAL_STORAGE_KEY = {
    TOKEN_KEY: 'token',
    REFRESH_TOKEN: 'refresh_token',
    USER_CURRENT_LOGIN: 'user',
    LANGUAGE: 'language',
    ORGANIZATION_ID: 'organization_id',
};